import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { getItemsWithNoJackpotCached } from '@/utils/jackpotsV2/getItemsWithNoJackpotCached';
import { getJackpotsV2ForGames } from '@/utils/jackpotsV2/getJackpotsV2ForGames';

export const getRecentlyPlayedJackpotsV2 = async (context: LogicContext) => {
  const currentJackpotsV2 = context.currentJackpotsV2;
  const allGames = context.user.recentlyPlayedGamesList || [];

  if (config?.features?.jackpotsV2?.mode !== 'enabled' || !currentJackpotsV2) {
    return {};
  }
  const filteredGames = getItemsWithNoJackpotCached(
    allGames,
    currentJackpotsV2
  );
  const currency = context.user?.currency || config.default_currency;

  return getJackpotsV2ForGames(filteredGames, currency);
};
